export default function VideoPlayer({ url }: { url: string }) {
  return (
    <div className="overflow-hidden rounded-lg border border-slate-200 bg-white">
      <video controls className="w-full" preload="metadata">
        <source src={url} />
        Il tuo browser non supporta il tag video.
      </video>
    </div>
  );
}
